import { createContext } from 'react'

import type { TableCellJustify, TableSize } from './table'

export type GetCellStylesOptions = {
  justify?: TableCellJustify
  noBorder?: boolean
}

export type TableContextProps = {
  size: TableSize

  // internal methods
  getCellStyles(opts?: GetCellStylesOptions): string
}
export const TableContext = createContext<TableContextProps>({
  size: 'md',
  getCellStyles: () => '',
})
